module.exports = __webpack_public_path__ + "img/puberty-decal-06.87a3b422.png";